import { FiStar } from '@/components/react-icons/main';
import utilityAppIcons from '@/screens/workflows/schema/utilityAppIcons.js';

// App definitions may carry a logo URL, a sprite name, or nothing at all. The utility
// icon map covers the platform apps; the star keeps every remaining cell recognizable.
const getFixerAppIcon = ({ icon, slug } = {}) => icon || utilityAppIcons[slug] || FiStar;

export default getFixerAppIcon;
